<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal" novalidate="" [formGroup]="editForm" (ngSubmit)="save(editForm.value)">
    <modal-header [plugin]="plugin" [menuModal]="menuModal"></modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div
        class="ir-content--modal th-content th-content-customer"
        formArrayName="actions"
        *ngFor="let item of formData.controls; let i = index"
      >
        <table class="ir-modal-table">
          <tr>
            <td></td>
            <td class="th-plugin-line--remove th-plugin-line--remove-customer" style="width: 50%" colspan="2" align="right">
              <i class="material-icons" (click)="openActionDeleteConfirm(i)">remove_circle</i>
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span>{{ 'plugins.actionscompleted.description' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big" style="width: 50%" [formGroupName]="i">
              <div class="ir-form-group">
                <input
                  type="text"
                  formControlName="Description"
                  class="ir-form-set"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span>{{ 'plugins.actionscompleted.time-required' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big" style="width: 50%" [formGroupName]="i">
              <div class="ir-form-group">
                <table class="ir-modal-table">
                  <tr>
                    <td style="width: 50%; padding-right: 10px">
                      <input
                        type="number"
                        formControlName="Hours"
                        placeholder="{{ 'plugins.actionscompleted.hours' | translate }}"
                        class="ir-form-set"
                        min="0"
                      />
                    </td>
                    <td style="width: 50%; padding-left: 10px">
                      <input
                        type="number"
                        formControlName="Minutes"
                        placeholder="{{ 'plugins.actionscompleted.minutes' | translate }}"
                        class="ir-form-set"
                        min="0"
                        max="59"
                      />
                    </td>
                  </tr>
                </table>
              </div>
            </td>
          </tr>
        </table>
        <h2>
          <span>{{ 'plugins.actionscompleted.comment' | translate }}</span>
        </h2>
        <div class="ir-form-group" [formGroupName]="i">
          <textarea
            id="comment"
            formControlName="Comment"
            rows="3"
            class="ir-form-set"
          ></textarea>
        </div>
      </div>
      <div class="ir-content--modal th-content th-content-plus">
        <table class="ir-modal-table">
          <tr class="th-plugin-line--add th-plugin-line--add-customer">
            <td colspan="4">
              <i class="material-icons" (click)="add()">add_circle</i>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <modal-footer [editForm]="editForm" [processing]="processing"></modal-footer>
  </form>
</div>
<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<confirm
  #actionDeleteConfirm
  (confirmOutput)="remove($event)"
  [title]="'common.delete-confirmation' | translate"
  [message]="'Are you sure to delete this <strong>action</strong>?'"
  [danger]="true"
></confirm>
<confirm
  #deleteConfirm
  (confirmOutput)="deletePlugin($event)"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.sure-to-delete' | translate"
  [danger]="true"
></confirm>
